import React from 'react';
import { CheckCircle, Clock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const TemporaryHousing: React.FC = () => {
    const navigate = useNavigate();

    const handleContactClick = () => {
        navigate('/eligibility?service=accommodation');
    };

    return (
        <div className="bg-white min-h-screen pt-32 pb-20">
            <div className="bg-[#009B8F] text-white py-16 mb-16">
                <div className="max-w-7xl mx-auto px-6">
                    <h1 className="text-4xl md:text-5xl font-serif mb-4">Temporary Housing Support</h1>
                    <p className="text-xl text-white/90 max-w-2xl">
                        Short-term accommodation solutions while you settle in.
                    </p>
                </div>
            </div>

            <div className="max-w-5xl mx-auto px-6">
                <div className="flex items-center gap-4 mb-8">
                    <div className="p-3 bg-[#009B8F]/10 rounded-full">
                        <Clock className="text-[#009B8F] w-8 h-8" />
                    </div>
                    <h2 className="text-3xl font-serif text-[#011E26]">Settle In With Peace of Mind</h2>
                </div>

                <div className="bg-amber-50 border-l-4 border-amber-500 p-4 mb-8">
                    <p className="text-amber-800 text-sm font-medium">
                        <strong>Note:</strong> NexOverseas is currently under construction and our services are operating exclusively in the UK.
                    </p>
                </div>

                <div className="prose prose-lg text-slate-600 max-w-none">
                    <p className="mb-4">
                        Arriving in a new country without permanent accommodation can be stressful. Our Temporary Housing Support service ensures you have a safe and comfortable place to stay while you search for long-term housing.
                    </p>
                    <p className="mb-4">
                        We arrange short-term stays in verified accommodations, giving you the time and flexibility to explore your options without pressure.
                    </p>

                    <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-[#009B8F] mb-8">
                        <h3 className="text-lg font-bold text-[#011E26] mb-3 uppercase tracking-wide">Our service includes:</h3>
                        <ul className="grid grid-cols-1 md:grid-cols-2 gap-3">
                            {[
                                "Verified short-term accommodation options",
                                "Flexible booking periods",
                                "Safe and comfortable living spaces",
                                "Support with transition to permanent housing"
                            ].map((item, i) => (
                                <li key={i} className="flex items-start gap-2 text-sm font-medium">
                                    <CheckCircle className="w-5 h-5 text-[#009B8F] flex-shrink-0" />
                                    <span>{item}</span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <p className="mb-6">
                        Let us take care of your initial housing needs so you can focus on settling into your new life abroad.
                    </p>

                    <button
                        onClick={handleContactClick}
                        className="bg-[#009B8F] text-white px-8 py-3 font-bold uppercase tracking-widest hover:bg-[#00857a] transition-colors rounded-sm shadow-lg"
                    >
                        Get in Touch
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TemporaryHousing;
